/**
 * Created by jonas on 2022-06-15.
 */
import {gsap} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {TheCage} from "../../TheCage";
import {TheCageSymbolStates} from "../../reels/TheCageSymbol";
import {ScatterSymbol} from "../../reels/ScatterSymbol";
import {ReelUtils} from "../../utils/ReelUtils";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";


export class FillUpPresentation implements SimplePresentation {
    name:string = "FillUpPresentation";

    constructor() {
    }

    shouldRun():boolean {
        return true;
    }

    start(controller:SimplePresentationRunnerController):void {
        const tl:gsap.core.Timeline = gsap.timeline({onComplete:() => controller.finish()});
        tl.add(() => controller.setSkipCallback(() =>{
            //tl.seek("ending", false);
            tl.timeScale(3);
        }));

        const isNearWinAllowed = TheCage.model.isNearWinAllowed();

        if (isNearWinAllowed){
            const allScatterDatas = TheCage.reelView.avalancheMatrixModel.getAllSymbolsWithNames(["S1", "S2"]);
            const allUnlockedScatters = [];

            for (let scatterData of allScatterDatas){
                allUnlockedScatters.push(scatterData);
                if (!scatterData.removed) {
                    ReelUtils.scatters.push(scatterData);
                }
            }

            const startScatters = gsap.timeline();
            if (allUnlockedScatters.length == 2){
                for (let scatterData of allUnlockedScatters){
                    if (scatterData.removed == false){
                        startScatters.add((<ScatterSymbol>scatterData.positionable).getStateAnimation(TheCageSymbolStates.ATTENTION), 0);
                    }
                }
            }

            tl.add(startScatters);
        }


        tl.add(TheCage.reelView.avalancheMatrixModel.fillUp(TheCage.model.gameData.reels,TheCage.model.data.symbolsAfterTumblePrev, isNearWinAllowed), "<");

        tl.to(this, {duration:0.01});

        if (TheCage.apiPlugin.settings.get(APISetting.FAST_SPIN)){
            tl.timeScale(1.4);
        }


    }
}